import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/tool/file/metadata/index.js